const CollapsibleTextComponent = require("./collapsible-text.component");

let CollapsibleTextService = function () {
    let $currentContext = $();

    var textList = [];

    function parseContext() {
        var $text = $(CollapsibleTextComponent.SELECTOR, $currentContext);

        $text.each((index, entry) => {
            var $textContext = $(entry);
            var text = new CollapsibleTextComponent();
            text.init($textContext);
            textList.push(text);
        });
    }

    this.init = function ($context) {
        $currentContext = $context || $currentContext;

        parseContext();
    };
};

module.exports = CollapsibleTextService;
